import React from "react";

import Modal from "components/UI/Modal/Modal";
import { TURNOS } from "../consts";
import styles from "./ResumenEmpleadoModal.module.scss";

/**
 * Desglose del mes de UN empleado: cuántos días lleva de cada código.
 *
 * La grilla muestra en su última columna solo los francos, que es lo que pide la planilla.
 * El resto del desglose vive acá para no robarle ancho a los días: una columna por código
 * serían cinco columnas fijas más.
 *
 * El total de días cargados cierra abajo. Si no llega a los días del mes es porque quedan
 * días sin cargar, y esa resta es la forma más directa de ver a quién le falta terminar.
 *
 * @param conteo   { [codigo]: cantidad } del empleado, ya calculado por la vista
 * @param diasDelMes cuántos días tiene el mes, para el "de N"
 */
export default function ResumenEmpleadoModal({
    open,
    empleado,
    mesLabel,
    conteo = {},
    diasDelMes,
    onClose,
}) {
    const cargados = TURNOS.reduce((acc, t) => acc + (conteo[t.codigo] ?? 0), 0);

    return (
        <Modal
            size="sm"
            open={open}
            title={`${empleado ?? ""} — ${mesLabel ?? ""}`}
            onClose={onClose}
        >
            <div className={styles.contenedor}>
                <table className={styles.tabla}>
                    <tbody>
                        {TURNOS.map((t) => (
                            <tr key={t.codigo}>
                                <td className={styles.codigo}>
                                    <span className={styles[`celdaTurno${t.codigo}`]}>
                                        {t.codigo}
                                    </span>
                                </td>
                                <td className={styles.label}>{t.label}</td>
                                {/* Franco y licencia no tienen horario: la celda queda vacía
                                    en vez de mostrar un guión que se lea como un dato. */}
                                <td className={styles.horario}>{t.horario ?? ""}</td>
                                <td className={styles.cantidad}>{conteo[t.codigo] ?? 0}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                <div className={styles.total}>
                    <span>Días cargados</span>
                    <strong>
                        {cargados}
                        {diasDelMes ? ` de ${diasDelMes}` : ""}
                    </strong>
                </div>
            </div>
        </Modal>
    );
}
